import React, {Component} from 'react'
import {Modal, ModalBody, ModayFooter, ModalHeader} from 'reactstrap'
import Form from 'react-jsonschema-form'

import AUSelectGenerator from "../auto_updaters/Select";
import ProjectBudgetSelection from './ProjectBudgetSelection'

const AUSelectUsers = AUSelectGenerator('active_users',
    'user_id first_name last_name',
    'user_id', ['first_name', 'last_name'])

const config = {
    schema: {
        title: 'Create Schedule',
        type: 'object',
        required: ['start_date', 'end_date', 'user_schedule_type_id', 'user_id', 'project_activity_budget_id'],
        properties: {
            start_date: {type: 'string', title: 'Start'},
            end_date: {type: 'string', title: 'End'},
            user_schedule_type_id: {type: 'integer', default: 1},
            user_id: {type: 'integer', title: 'User'},
            project_activity_budget_id: {type: 'integer', title: 'Project/Budget'}
        }
    },
    uiSchema: {
        start_date: {
            "ui:widget": "datetime"
        },
        end_date: {
            "ui:widget": "datetime"
        },
        user_schedule_type_id: {
            "ui:widget": "hidden"
        },
        user_id: {
            "ui:widget": "usersSelect"
        },
        project_activity_budget_id: {
            "ui:widget": "projectBudgetSelect"
        }
    },
    widgets: {
        usersSelect: AUSelectUsers,
        projectBudgetSelect: ProjectBudgetSelection
    }
}

export default class CreateSchedule extends Component{

    render(){
        return (
            <Form
                {...config}
                formData={this.props.formData || {}}
                onSubmit={(data) => this.props.onSubmit && this.props.onSubmit(data)}
                onChange={(data) => this.props.onChange && this.props.onChange(data)}
                transformErrors={errors => errors.filter(error => error.hasOwnProperty('instance'))}
            >
                {this.props.children}
            </Form>
        )
    }

}